module.exports = __webpack_public_path__ + "img/sidebar-battery-9.9a5c8a13.svg";